import { CARD_IDS } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import {
  getPremiumOptions,
  getTopOptions
} from '@/components/AdvertisePayments/components/Options/Options.helpers';

export const useContentOptionsConfig = () => {
  return {
    [CARD_IDS.TOP]: {
      options: getTopOptions
    },
    [CARD_IDS.PREMIUM]: {
      options: getPremiumOptions
    }
  } as const;
};
